<template>
    <el-drawer
        :title="detailData.title"
        :visible.sync="componentData.visible"
        size="520px"
        :close-on-press-escape="false"
        :wrapperClosable="false"
    >
        <div class="drawer-wrapper">
            <div class="drawer-main" v-loading="detailData.loading.main">
                <div class="drawer-body">
                    <el-form :model="detailData" ref="detailData" size="small">
                        <el-form-item
                            label="主题："
                            prop="row.title"
                            :rules="[{ required: true, message: '填写活动主题', trigger: 'blur' }]"
                        >
                            <el-input v-model="detailData.row.title"></el-input>
                        </el-form-item>
                        <el-form-item
                            label="类型："
                            prop="row.type"
                            :rules="[{ required: true, message: '选择活动类型', trigger: 'blur' }]"
                        >
                            <el-select v-model="detailData.row.type">
                                <el-option :key="1" label="抽奖" :value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="免费参与次数/天/人"
                            prop="row.available"
                            :rules="[
                                {
                                    required: true,
                                    message: '填写活动免费参与次数/天/人',
                                    trigger: 'blur'
                                }
                            ]"
                        >
                            <el-input-number
                                controls-position="right"
                                v-model="detailData.row.available"
                            ></el-input-number>
                        </el-form-item>
                        <el-form-item
                            label="最大参与次数/天/人"
                            prop="row.count"
                            :rules="[
                                {
                                    required: true,
                                    message: '填写活动最大参与次数/天/人',
                                    trigger: 'blur'
                                }
                            ]"
                        >
                            <el-input-number
                                controls-position="right"
                                v-model="detailData.row.count"
                            ></el-input-number>
                        </el-form-item>
                        <el-form-item
                            label="活动周期："
                            prop="row.times"
                            :rules="[
                                { required: true, message: '选择活动起止时间', trigger: 'blur' }
                            ]"
                        >
                            <el-date-picker
                                v-model="detailData.row.times"
                                type="datetimerange"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                            ></el-date-picker>
                        </el-form-item>
                        <template v-for="(row, index) in detailData.row.prizes">
                            <el-row :key="index" :gutter="10">
                                <el-col :span="10">
                                    <el-form-item
                                        :label="!index ? '奖品：' : ''"
                                        :prop="'row.prizes.' + index + '.prizetitle'"
                                        :rules="[
                                            {
                                                required: true,
                                                message: '填写活动奖品',
                                                trigger: 'blur'
                                            }
                                        ]"
                                    >
                                        <el-input v-model="row.prizetitle">
                                            <template v-if="index">
                                                <el-button
                                                    slot="append"
                                                    icon="el-icon-delete"
                                                    @click="RemovePrize(index)"
                                                ></el-button>
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7">
                                    <el-form-item
                                        :label="!index ? '数量：' : ''"
                                        :prop="'row.prizes.' + index + '.prizecount'"
                                        :rules="[
                                            {
                                                required: true,
                                                message: '填写奖品数量',
                                                trigger: 'blur'
                                            }
                                        ]"
                                    >
                                        <el-input-number
                                            v-model="row.prizecount"
                                            :min="1"
                                            :step="1"
                                            controls-position="right"
                                        ></el-input-number>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7">
                                    <el-form-item
                                        :label="!index ? '中奖率：' : ''"
                                        :prop="'row.prizes.' + index + '.rate'"
                                        :rules="[
                                            {
                                                required: true,
                                                message: '填写奖品中奖率',
                                                trigger: 'blur'
                                            }
                                        ]"
                                    >
                                        <el-input-number
                                            v-model="row.rate"
                                            :min="0"
                                            :max="100"
                                            :step="0.01"
                                            controls-position="right"
                                        ></el-input-number>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                        <el-form-item>
                            <el-button
                                type="primary"
                                plain
                                icon="el-icon-circle-plus-outline"
                                @click="AddPrize"
                                >奖品</el-button
                            >
                        </el-form-item>
                        <el-form-item label="备注：" prop="row.remarks">
                            <el-input type="textarea" v-model="detailData.row.remarks"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                size="small"
                                :loading="detailData.loading.submit"
                                @click="SubmitlDetail('detailData')"
                                >保 存</el-button
                            >
                            <el-button size="small" @click="componentData.visible = false"
                                >取 消</el-button
                            >
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
export default {
    inject: ['reload'],
    props: ['componentData'],
    data() {
        return {
            detailData: {
                loading: {
                    main: false,
                    submit: false
                },
                title: '活动详情',
                row: {
                    id: null,
                    title: null,
                    type: 1,
                    available: null,
                    count: null,
                    times: [],
                    starttime: null,
                    endtime: null,
                    prizes: [
                        {
                            prizetitle: null,
                            prizecount: null,
                            rate: null
                        }
                    ],
                    prize: null,
                    remarks: null
                }
            }
        }
    },
    created() {
        this.$nextTick(() => {})
    },
    mounted() {
        this.$nextTick(() => {
            if (this.componentData.row && this.componentData.row.id) {
                this.GetDetail()
            }
        })
    },
    methods: {
        AddPrize() {
            this.detailData.row.prizes.push({
                prizetitle: null,
                prizecount: null,
                rate: null
            })
        },
        RemovePrize(index) {
            this.detailData.row.prizes.splice(index, 1)
        },
        GetDetail() {
            this.detailData.row = {
                id: this.componentData.row.id,
                title: this.componentData.row.title,
                type: parseInt(this.componentData.row.type),
                available: this.componentData.row.available,
                count: this.componentData.row.count,
                times: [this.componentData.row.starttime, this.componentData.row.endtime],
                prizes: JSON.parse(this.componentData.row.prize),
                remarks: this.componentData.row.remarks
            }
        },
        SubmitlDetail(formName) {
            this.detailData.row.starttime = this.detailData.row.times[0]
            this.detailData.row.endtime = this.detailData.row.times[1]
            this.detailData.row.prize = JSON.stringify(this.detailData.row.prizes)
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.detailData.loading.submit = true
                    this.$request({
                        url:
                            this.componentData.row && this.componentData.row.id
                                ? '/api/v1/editeluckdraw'
                                : '/api/v1/addluckdraw',
                        method: 'POST',
                        data: this.$qs.stringify(this.detailData.row)
                    }).then(res => {
                        this.detailData.loading.submit = false
                        this.$message({
                            message: res.message || (res.status ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                        if (!res.status) {
                            this.reload()
                        }
                    })
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/drawer.less';
</style>
